<template>
  <modal-template ref="modal">
    <template v-slot:title>
      {{ lang.modals.delete_offer.headline }}
    </template>

    <template v-slot:default>
      <h3
        class="text-lg text-gray-900"
        v-html="lang.modals.delete_offer.sub_headline"
      ></h3>
      <div class="mt-4 md:grid md:grid-cols-2 gap-4 md:space-y-0 space-y-4">
        <plain-button color="default" @click="soldWithUd('false')">{{
          lang.labels.no
        }}</plain-button>
        <plain-button color="primary" @click="soldWithUd('true')">{{
          lang.labels.yes
        }}</plain-button>
      </div>
    </template>
  </modal-template>
</template>

<script setup>
import { ref } from "vue";
import ModalTemplate from "./ModalTemplate.vue";

// Props
const props = defineProps({
  lang: Object,
  modalData: Object,
});

// Emits
const emit = defineEmits(["delete-offer"]);

// Template refs
const modal = ref(null);

// Methods
const showModal = () => {
  modal.value.showModal();
};

const hideModal = () => {
  modal.value.hideModal();
};

/**
 * send selection to server
 * @param bool sold
 */
const soldWithUd = (sold) => {
  updateStats(sold);
  deleteOffer();
  hideModal();
};

/**
 * update sold stats
 * @param bool sold
 */
const updateStats = (sold) => {
  axios
    .post(
      `/web-api/user/offer/delete-offer-sold-stats/${props.modalData.offer.id}`,
      {
        soldWithUsedDesign: sold,
      }
    )
    .then((response) => {
      // console.log(response);
    })
    .catch((error) => {
      // console.log(error)
    });
};

/**
 * delete offer
 */
const deleteOffer = () => {
  emit("delete-offer");
};

// Expose methods for parent component access
defineExpose({
  showModal,
  hideModal,
});
</script>
